<template>
  <footer class="footer">
    <DefaultSection class="footer_section">
      <Container>
        <div class="columns">
          <div class="column is-one-quarter is-hidden-mobile">
            <img
              alt="Logo"
              src="~/assets/svgs/logo-claim.svg?url"
              data-not-lazy
            />
          </div>
          <div class="column is-one-third">
            <FooterMenu />
          </div>
          <div class="column">
            <div class="columns store-buttons is-multiline is-mobile">
              <div
                class="column is-is-half is-full-tablet has-text-right-tablet"
              >
                <a
                  href="https://apps.apple.com/ch/app/lessmess/id1459787403"
                  target="_blank"
                  class="is-block-tablet firstbutton"
                >
                  <img
                    alt="App Store Button"
                    src="~/assets/svgs/buttons/app_store_white.svg?url"
                    data-not-lazy
                  />
                </a>
              </div>
              <div
                class="column is-is-half is-full-tablet has-text-right-tablet"
              >
                <a
                  class="is-block-tablet"
                  href="https://play.google.com/store/apps/details?id=ch.extramedica.lezzmezz"
                  target="_blank"
                >
                  <img
                    alt="Google Play Button"
                    src="~/assets/svgs/buttons/google_play_white.svg?url"
                    data-not-lazy
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </DefaultSection>

    <DefaultSection class="py-0 subfooter has-background-primary">
      <Container>
        <div class="columns my-0">
          <div class="column is-half social-icons">
            <a
              href="https://www.facebook.com/LessMessApp"
              target="_blank"
              class="pr-5 mr-5"
            >
              <Facebook alt="Facebook" />
            </a>
            <a
              href="https://twitter.com/lessmessapp"
              target="_blank"
              class="pr-5 mr-5"
            >
              <Twitter alt="Twitter" />
            </a>
            <a
              href="https://www.instagram.com/lessmessapp"
              target="_blank"
              class="pr-5 mr-5"
            >
              <Instagram alt="Instagram"
            /></a>
            <a
              href="https://medium.com/@lessmessapp"
              target="_blank"
              class="pr-5 mr-5"
              ><Medium alt="Medium"
            /></a>
          </div>
          <div class="column is-offset-1">
            <FooterSubMenu />
          </div>
        </div>
      </Container>
    </DefaultSection>
  </footer>
</template>

<script setup lang="ts">
import Facebook from '~/assets/svgs/icons/ic24-facebook.svg?component'
import Twitter from '~/assets/svgs/icons/ic24-twitter.svg?component'
import Medium from '~/assets/svgs/icons/ic24-medium.svg?component'
import Instagram from '~/assets/svgs/icons/ic24-instagram.svg?component'
</script>

<style scoped lang="scss">
footer {
}

.footer_section {
  padding-top: toRem(80);
  padding-bottom: toRem(80);

  .store-buttons {
    margin-top: toRem(20);

    svg {
      max-width: 150px;
    }

    @include tablet {
      margin-top: 0;
      max-width: unset;
      .firstbutton {
        margin-bottom: -1rem;
      }
    }
  }
}

.subfooter {
  .social-icons {
    @include mobile {
      display: flex;
      justify-content: space-between;
    }

    a:last-of-type {
      margin-right: 0 !important;
      padding-right: 0 !important;
    }
  }
}
</style>
